<script>
export default {
	props: {
		img: String,
		label: String,
		graduationRange: Array,
	},
	data() {
		return { graduation: null }
	},
	watch: {
		graduation(val) {
			this.$emit('update:graduation', val)
		},
	},
}
</script>

<template>
	<GraduationSelector-Wrapper :img="img">
		<GraduationSelector-Select
			:items="graduationRange"
			v-model="graduation"
			:title="`Graduación Ojo ${label}`"
		/>
	</GraduationSelector-Wrapper>
</template>

<style></style>
